import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { TimePicker, DatePicker } from '@web-lite/scroll-picker'
import { DatePickerModal } from './date-picker-modal'

import { t } from '$i18n'
import {
  getDateOfNDaysLater,
  getDateOfNMinutesLater,
  getDateOfNYearsAgo,
} from '$comp/modals/date-picker/date-picker.helper'

const COMPONENT_ID = 'datePickerModal'

const showDatePickerModal = (props: Parameters<typeof DatePickerModal>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export const showBirthdatePickerModal = (
  onComplete: (value: Date) => unknown,
  birthdate?: Date,
) =>
  showDatePickerModal({
    Children: DatePicker,
    headerText: t('datePickerModal.birthdate.title'),
    onConfirm: onComplete,
    onClose: closeCurrentModal,
    defaultValue: birthdate || getDateOfNYearsAgo(1),
    start: getDateOfNYearsAgo(100),
    end: new Date(),
  })

export const showInviteLineExpireDatePickerModal = (
  onComplete: (value: Date) => unknown,
  expiresAt?: Date,
) =>
  showDatePickerModal({
    Children: TimePicker,
    headerText: t('datePickerModal.inviteLinkExpireDate.title'),
    onConfirm: onComplete,
    onClose: closeCurrentModal,
    start: getDateOfNMinutesLater(1),
    end: getDateOfNDaysLater(30),
    defaultValue:
      expiresAt && expiresAt > new Date()
        ? expiresAt
        : getDateOfNMinutesLater(1),
  })

export default {
  [COMPONENT_ID]: {
    Component: DatePickerModal,
  },
}
